import { Alert, CardMedia, Stack, Typography } from '@mui/material';
import { TaskInstruction } from '../../../api/generated';
import { useEffect } from 'react';
import { SelfServiceInstructionProps } from './InstructionComponent';

export default function TaskInstructionComponent({
  instruction,
  onReadyStatusChange,
}: SelfServiceInstructionProps<TaskInstruction>) {
  const { description, imageUrl, error } = instruction.parameters;

  useEffect(() => {
    onReadyStatusChange(true);
  }, [onReadyStatusChange]);

  return (
    <Stack gap={2}>
      {error?.message && <Alert severity='error'>{error.message}</Alert>}
      {imageUrl && (
        <CardMedia
          component='img'
          src={imageUrl}
          sx={{
            objectFit: 'contain',
            maxHeight: '100%',
            maxWidth: '100%',
            borderRadius: '10px',
          }}
        />
      )}
      {description && (
        <Typography variant='h6' color='text.secondary' sx={{ mb: 2 }}>
          {description}
        </Typography>
      )}
    </Stack>
  );
}
